import debounce from '../utils/debounce';
import setCssVar from '../utils/setCssVar';

export default class Header {
  constructor(elem, APP) {
    this.APP = APP;
    this.APP.header = {
      state: null,
      height: null,
      setSkin: (skin) => this.elem.dataset.skin = skin,
    };
    this.elem = elem;
    this.hamburgerBtn = this.elem.querySelector('.js-header-hamburger-btn');
    this.classes = {
      noScroll: 'no-scroll',
      opened: 'header--open',
      default: 'header--normal',
      expanded: 'header--expanded',
      collapsed: 'header--collapsed',
      animate: 'header--animate',
    };
    this.body = document.querySelector('body');
    this.deviceType = null;
    this.previousDeviceType = null;
    this.triggers = this.elem.querySelectorAll('.js-accgrid-trigger');
    this.panels = this.elem.querySelectorAll('.js-accgrid-panel');
    this.navBarHeight = this.elem.offsetHeight;
    this.parentLinks = this.elem.querySelectorAll('.js-parent-link');
    this.previousScrollTop = null;
    this.isInitialScrollEvent = true;
    this.headerState = null;
    this.mainSections = document.querySelector(".single-mlp_articles")
      ? document.querySelectorAll("main > section, .article section, .article p, .article figure")
      : document.querySelectorAll("main > section, main > * > section");
    this.isHome = document.body.classList.contains('home');
    this.scrollBuffer = this.navBarHeight;
  }


  hamburgerButtonHandler() {
    this.elem.classList.toggle(this.classes.opened);
    this.body.classList.toggle(this.classes.noScroll);

    if (this.elem.classList.contains(this.classes.opened)) {
      this.resetMenus();
    }
  }

  deviceEventController() {
    const isMobile = window.matchMedia('(max-width: 1199px)').matches;
    const isDesktop = window.matchMedia('(min-width: 1200px)').matches;

    if (isMobile) {
      this.deviceType = 'mobile';
      if (this.previousDeviceType === this.deviceType) return;
      // mobile setup, desktop teardown
      this.hamburgerBtn.addEventListener('click', this.hamburgerButtonHandler.bind(this));
      this.navBarHeight = this.elem.offsetHeight;
    }
    if (isDesktop) {
      this.deviceType = 'desktop';
      this.setLeftPosition();
      if (this.previousDeviceType === this.deviceType) return;
      // desktop setup, mobile teardown
      this.elem.classList.remove(this.classes.opened);
      this.body.classList.remove(this.classes.noScroll);
      this.onHoverHandler();
      this.navBarHeight = this.elem.offsetHeight;
    }

    setCssVar(null, '--header-height', `${this.navBarHeight}px`);
    this.previousDeviceType = isMobile ? 'mobile' : 'desktop';
  }

  resetMenus() {
    this.triggers.forEach((trigger) => {
      trigger.setAttribute("aria-expanded", false);
    })

    this.panels.forEach((panel) => {
      panel.classList.remove("expanded");
      panel.style.height = 0;
      panel.setAttribute("aria-hidden", true);
    })
  }

  onHoverHandler() {
    this.parentLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        this.setSubnavHeight(link);
      });

      // add focus event for accessibility
      link.addEventListener('focusin', () => {
        this.setSubnavHeight(link);
      });
    });
  }

  setSubnavHeight(link) {
    const subnav = link.querySelector('.js-subnav');
    const subnavHeight = subnav.offsetHeight;
    this.elem.style.setProperty('--subnav-height', `${subnavHeight}px`);
  }

  setLeftPosition() {
    this.parentLinks.forEach((item) => {
      // set a css variable for the left position of the parent link
      const parentRect = item.getBoundingClientRect();
      const parentLeft = parentRect.left;
      item.style.setProperty('--parent-link-position', `${parentLeft}px`);
    });
  }

  onScroll() {
    const scrollPos = window.scrollY;
    const isScrollingDown = scrollPos > this.previousScrollTop;
    const isScrollingUp = scrollPos < this.previousScrollTop;
    const isScrollPosAfterNavBar = scrollPos > this.navBarHeight;
    const isScrollPosAtTop = scrollPos <= 0;
    const isHeaderNormal = this.elem.classList.contains(this.classes.default);
    // const isAbnormalScroll = scrollPos < (this.previousScrollTop - (this.scrollBuffer * 2)) || scrollPos > (this.previousScrollTop + (this.scrollBuffer * 2));

    // console.table({
    //   scrollPos,
    //   isScrollingDown,
    //   isScrollingUp,
    //   isScrollPosAfterNavBar,
    //   isScrollPosAtTop,
    //   isHeaderNormal,
    //   isAbnormalScroll,
    // });

    // preflight checks, eg, if the user reloaded the page below the fold
    if (this.isInitialScrollEvent) {
      this.previousScrollTop = scrollPos;
      setCssVar(null, '--header-height-dynamic', '0px');

      if (isScrollPosAfterNavBar) {
        this.elem.classList.add(this.classes.animate, this.classes.expanded)
        this.elem.classList.remove(this.classes.default)
        setCssVar(null, '--header-height-dynamic', `${this.elem.offsetHeight}px`);
      }

      this.isInitialScrollEvent = false;
      return;
    };

    // detecting abnormal scroll events, e.g. document reflow
    // if (isAbnormalScroll) {
    //   this.previousScrollTop = scrollPos;
    //   return;
    // }

    if (this.previousScrollTop === null) return;

    if (isScrollingDown && isScrollPosAfterNavBar) {
      if (Math.abs(this.previousScrollTop - scrollPos) <= this.scrollBuffer) return;
      setCssVar(null, '--header-height-dynamic', '0px');
      this.APP.header.state = 'collapsed';
      this.APP.header.height = 0;

      if (isHeaderNormal) {
        this.elem.classList.add(this.classes.collapsed);
        this.elem.classList.remove(this.classes.animate, this.classes.expanded, this.classes.default);
      } else {
        this.elem.classList.add(this.classes.animate, this.classes.collapsed);
        this.elem.classList.remove(this.classes.expanded, this.classes.default);
      }
    }

    if (isScrollingUp) {
      setCssVar(null, '--header-height-dynamic', `${this.elem.offsetHeight}px`);
      this.APP.header.height = this.elem.offsetHeight;

      if (isScrollPosAtTop) {
        this.elem.classList.remove(this.classes.animate, this.classes.expanded, this.classes.collapsed);
        this.elem.classList.add(this.classes.default);
        this.APP.header.state = 'normal';
      } else if (isScrollPosAfterNavBar && Math.abs(this.previousScrollTop - scrollPos) <= this.scrollBuffer) {
        this.elem.classList.add(this.classes.animate, this.classes.expanded);
        this.elem.classList.remove(this.classes.collapsed, this.classes.default);
        this.APP.header.state = 'expanded';
      } else if (!isHeaderNormal && Math.abs(this.previousScrollTop - scrollPos) <= this.scrollBuffer) {
        this.elem.classList.add(this.classes.animate, this.classes.expanded);
        this.elem.classList.remove(this.classes.collapsed, this.classes.default);
        this.APP.header.state = 'expanded';
      }
    }
    this.previousScrollTop = scrollPos;
  }

  setMainContentNavSkin() {
    this.mainSections.forEach(section => {
      // do nothing if the navSkin is already set
      if (section.dataset?.navSkin) return;

      // otherwise, set the navSkin based on the brightness of the background color
      const computedStyle = window.getComputedStyle(section);
      const bgColor = computedStyle.backgroundColor;
      const rgb = bgColor.match(/\d+/g);
      const brightness = Math.floor(((parseInt(rgb[0]) * 299) + (parseInt(rgb[1]) * 587) + (parseInt(rgb[2]) * 114)) / 1000);

      switch (rgb.join(',')) {
        case '7,25,69':
          section.dataset.navSkin = 'dark';
          break;
        case '255,255,255':
          section.dataset.navSkin = 'light';
          break;
        case '6,31,130':
          section.dataset.navSkin = 'dark';
          break;
        default:
          section.dataset.navSkin = brightness > 250 ? 'dark' : 'light';
          break;
      }
    });
  }

  watchForHeaderSkinChange() {
    const topMargin = (this.navBarHeight).toFixed(0);
    const bottomMargin = (window.innerHeight - topMargin).toFixed(0);
    const observerOptions = {
      "rootMargin": `-${topMargin}px 0px -${bottomMargin}px 0px`,
      "threshold": [0],
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.target.dataset.navSkin || this.elem.dataset.skin === entry.target.dataset.navSkin) return;
        if (entry.isIntersecting) {
          this.elem.dataset.skin = entry.target.dataset.navSkin;
        };
      })
    }, observerOptions)

    this.mainSections.forEach(section => {
      observer.observe(section)
    });

    this.elem.dataset.skin = this.mainSections[0]?.dataset?.navSkin;
  }

  init() {
    this.APP.header.height = this.elem.offsetHeight;
    this.APP.header.state = 'normal';

    this.setMainContentNavSkin();
    this.watchForHeaderSkinChange();
    this.deviceEventController();
    window.addEventListener('resize', () => debounce(this.deviceEventController(), 200));
    window.addEventListener('scroll', this.onScroll.bind(this));
  }
}
